import * as React from 'react'
import { StyledCountInfo, StyledCountNumber } from './CountInfo.styled'

export interface CountInfoProps {
  hover?: boolean
  color?: string
  children?: React.ReactNode
  onClick?: (e?: React.MouseEvent) => void
}

export const CountInfoStorybook: React.FC<CountInfoProps> = ({
  children,
  ...props
}) => (
  <StyledCountInfo {...props}>
    <StyledCountNumber>{children}</StyledCountNumber>
  </StyledCountInfo>
)
